import { render, staticRenderFns } from "./ChooseClientModal.vue?vue&type=template&id=0ea81bf2&scoped=true"
import script from "./ChooseClientModal.vue?vue&type=script&lang=js"
export * from "./ChooseClientModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseClientModal.vue?vue&type=style&index=0&id=0ea81bf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea81bf2",
  null
  
)

export default component.exports